import { removeDupes, cleanObject } from '../utils/helpers';

const DEFAULT_STATE = {
    items: [],
    fetchInfo: {
        team: {
            all: {}
        },
        project: {}
    }
}

const getKey = (payload) => payload.projectId ? 'project' : 'team';

const tasksViews = (state = { ...DEFAULT_STATE }, action) => {
    if (action.error) {
        return state;
    }

    switch (action.type) {
        case 'TEAM_CHANGE':
        case 'RESET_STORE':
            return { ...DEFAULT_STATE };

        case 'MARK_ALL_FOR_REFETCH':
            return Object.assign({}, state, {
                items: [...state.items.map(tasksView => ({
                    ...tasksView,
                    shouldRefetch: true
                }))]
            });

        case 'TASKS_VIEWS_FETCH_REQUESTED':
            return Object.assign({}, state, {
                fetchInfo: {
                    ...state.fetchInfo,
                    [getKey(action.payload)]: {
                        ...state.fetchInfo[getKey(action.payload)],
                        [action.payload.projectId || 'all']: {
                            loading: true
                        }
                    }
                }
            });

        case 'TASKS_VIEWS_FETCH_SUCCEEDED':
            if (!action.payload.tasksViews) {
                return state;
            }

            return Object.assign({}, state, {
                items: removeDupes([
                    ...action.payload.tasksViews,
                    ...state.items
                ]),
                fetchInfo: {
                    ...state.fetchInfo,
                    [getKey(action.payload)]: {
                        ...state.fetchInfo[getKey(action.payload)],
                        [action.payload.projectId || 'all']: {
                            loading: false,
                            fetched: true,
                            error: false
                        }
                    }
                }
            });

        case 'TASKS_VIEWS_FETCH_FAILED':
            return Object.assign({}, state, {
                items: removeDupes([
                    ...action.payload.tasksViews,
                    ...state.items
                ]),
                fetchInfo: {
                    ...state.fetchInfo,
                    [getKey(action.payload)]: {
                        ...state.fetchInfo[getKey(action.payload)],
                        [action.payload.projectId || 'all']: {
                            ...state.fetchInfo[getKey(action.payload)][action.payload.projectId || 'all'],
                            loading: false,
                            fetched: true,
                            error: true
                        }
                    }
                }
            });

        case 'TASKS_VIEW_CREATE_REQUESTED':
        case 'TASKS_VIEW_ADD_SOCKET':
            return Object.assign({}, state, {
                items: removeDupes([action.payload.tasksView, ...state.items])
            });

        case 'TASKS_VIEW_CREATE_FAILED':
            return Object.assign({}, state, {
                items: state.items.filter(tasksView => tasksView !== action.payload.fragment)
            });

        case 'TASKS_VIEW_CREATE_SUCCEEDED':
            return Object.assign({}, state, {
                items: state.items
                    .filter(tasksView => tasksView.id !== action.payload.tasksViewId)
                    .map(tasksView => {
                        if (tasksView === action.payload.fragment) {
                            tasksView.id = action.payload.tasksViewId;
                        }

                        return tasksView;
                    })
            });

        case 'TASKS_VIEW_UPDATE_REQUESTED':
        case 'TASKS_VIEW_UPDATE_SOCKET': {
            const props = (action.payload.tasksViewProps || action.payload.tasksView);
            const isDefault = props.is_default;
            const existing = state.items.find(view => view.id === action.payload.tasksViewId);

            return Object.assign({}, state, {
                items: [...state.items].map(tasksView => {
                    if (tasksView.id === action.payload.tasksViewId) {
                        return Object.assign({}, tasksView, cleanObject(props));
                    }

                    if (isDefault &&
                        tasksView.is_default &&
                        tasksView.type === existing.type &&
                        (!existing.project_id || existing.project_id === tasksView.project_id)
                    ) {
                        return {
                            ...tasksView,
                            is_default: false
                        };
                    }

                    return tasksView;
                })
            });
        }

        case 'TASKS_VIEW_REMOVE_REQUESTED':
        case 'TASKS_VIEW_REMOVE_SOCKET':
            return Object.assign({}, state, {
                items: [...state.items].map(tasksView => {
                    if (tasksView.id === action.payload.tasksViewId) {
                        return {
                            id: tasksView.id,
                            removed: true
                        };
                    }

                    return tasksView;
                })
            });

        default:
            return state;
    }
}

export default tasksViews;
